import { type RouteObject } from 'react-router';

export const routes: RouteObject[] = [
    {
        lazy: async () => {
            const { Layout } = await import('@@routes/collections');

            return { Component: Layout };
        },
        children: [
            { index: true, element: null },
            {
                path: ':collectionId',
                lazy: async () => {
                    const { default: CollectionForm } =
                        await import('@@routes/collections/CollectionForm');

                    return { Component: CollectionForm };
                },
            },
        ],
    },
];
